
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[pillar]/[city]/[hood]/[configId]",
      function () {
        return require("private-next-pages/[pillar]/[city]/[hood]/[configId]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[pillar]/[city]/[hood]/[configId]"])
      });
    }
  